import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {
  PairsParams,
  MatchOptionList,
  MatchAttempt,
  MatchPairList,
} from './types';
import {cachedMatchResponses} from './matchQuestion.cache';

export function fetchMatchOptionsRequest(id?: string | number) {
  return useSWR<MatchOptionList>(
    [`/api/v1/questions/${id}/pairs/`],
    ([url]) =>
      letrusAPI(url)
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
    {shouldRetryOnError: false, revalidateOnFocus: false},
  );
}

export function postMatchAnswersRequest() {
  return useSWRMutation<MatchPairList, Error, string, MatchAttempt>(
    `/api/v1/question_attempts/matching/`,
    async (url, {arg}) => {
      try {
        // update matching_responses cached values for offline use, so the user cannot retake the test offline
        await cachedMatchResponses.update(
          {
            question_id: arg.question_id,
            step_id: arg.step_id,
            lpui_id: arg.learning_path_user_instance_id,
          },
          arg.responses,
        );

        const response = await letrusAPI(url, {
          method: 'post',
          data: arg,
        });
        return response.data;
      } catch (error: any) {
        throw Error(error);
      }
    },
    {throwOnError: false},
  );
}

export function fetchMatchResponseRequest(params: PairsParams) {
  return useSWR<MatchPairList>(
    [`/api/v1/question_attempts/matching_responses/`, params],
    ([url, params]) =>
      letrusAPI(url, {params})
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
    {shouldRetryOnError: false, revalidateOnFocus: false},
  );
}
